"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getBrandingSettings", {
  enumerable: true,
  get: function get() {
    return _getBrandingSettings["default"];
  }
});
Object.defineProperty(exports, "syncBrandingSettings", {
  enumerable: true,
  get: function get() {
    return _syncBrandingSettings["default"];
  }
});
var _getBrandingSettings = _interopRequireDefault(require("./getBrandingSettings"));
var _syncBrandingSettings = _interopRequireDefault(require("./syncBrandingSettings"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }